import { CalendarToday } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { DATE_TIME_FORMAT_NO_TIME, formatDate } from '../modules/date-helpers';
import { LocalDateSummaryStatistics } from '../modules/generated/api';

import IconValue from './IconValue';
import PackageDetailMinMaxRows from './PackageDetailMinMaxRows';

type PackageDetailTileFirstRegProps = {
  firstRegistration?: LocalDateSummaryStatistics;
};

const PackageDetailTileFirstReg = ({ firstRegistration }: PackageDetailTileFirstRegProps) => {
  const { t } = useTranslation();

  return (
    <IconValue icon={CalendarToday} label={t('car.firstRegistration')} padding>
      <PackageDetailMinMaxRows
        min={formatDate(firstRegistration?.min || '', DATE_TIME_FORMAT_NO_TIME)}
        avg={formatDate(firstRegistration?.avg || '', DATE_TIME_FORMAT_NO_TIME)}
        max={formatDate(firstRegistration?.max || '', DATE_TIME_FORMAT_NO_TIME)}
      />
    </IconValue>
  );
};

export default PackageDetailTileFirstReg;
